import script from "./RemoveEmployeeFromPayrollForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./RemoveEmployeeFromPayrollForm.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__